import { render, staticRenderFns } from "./ChartDetails.vue?vue&type=template&id=9d37aaf2&scoped=true"
import script from "./ChartDetails.vue?vue&type=script&lang=js"
export * from "./ChartDetails.vue?vue&type=script&lang=js"
import style0 from "./ChartDetails.vue?vue&type=style&index=0&id=9d37aaf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d37aaf2",
  null
  
)

export default component.exports